<ng-container *ngIf="initialized">

    <mvs-crud-object [objectType]="'cm.Contract'"
                     (onChangedObject)="handleObject($event)"

    ></mvs-crud-object>

</ng-container>